import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/total-darklogo.png'


const _hoisted_1 = { class: "row justify-between footer" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "footer-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "TotalEnergies",
    width: "68"
  })
], -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "q-pt-md"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Equipment List")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Equipment Details")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Reporting")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "q-pt-md" }, "Powered by TDF", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    class: "bg-secondary",
    elevated: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  (_ctx.account && _ctx.getSelectedSite)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                          to: {
                  name: 'EquipmentList',
                  params: {
                    countryBloc: _ctx.getSelectedCountryBloc,
                    site: _ctx.getSelectedSite,
                  },
                },
                          class: "accessibility-links"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"]),
                        _hoisted_6,
                        _createVNode(_component_router_link, {
                          to: {
                  name: 'EquipmentDetails',
                  params: {
                    countryBloc: _ctx.getSelectedCountryBloc,
                    site: _ctx.getSelectedSite,
                  },
                },
                          class: "accessibility-links"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"]),
                        _hoisted_8,
                        _createVNode(_component_router_link, {
                          to: {
                  name: 'EquipmentReporting',
                  params: {
                    countryBloc: _ctx.getSelectedCountryBloc,
                    site: _ctx.getSelectedSite,
                  },
                },
                          class: "accessibility-links"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_10
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}